/* eslint-disable react/no-unused-state */
/* eslint-disable indent */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
import * as H from 'history'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ApplicationForm1 } from './pages/applicationForm-1'
import { ApplicationForm2 } from './pages/applicationForm-2'
import { DashboardPage } from './pages/DashboardPage'
import { Guide } from './pages/Guide'
import { LoginPage } from './pages/LoginPage'
import { ProfilePage } from './pages/ProfilePage'
import { RequestPage } from './pages/RequestPage'
import { LogoutPage } from './pages/LogoutPage'
import { Announcement } from './pages/announcement'
import { ThreadsPage } from './pages/ThreadsPage'
import { DashboardFormsPage } from './pages/applicationForm-1/DashboardFormsPage'

// import { DashboardReformPage } from './pages/applicationForm-2/DashboardReformPage'
import ApplicationDetails from './pages/applicationForm-2/ApplicationDetails/index'
import AcceptForm from './pages/applicationForm-2/ApplicationDetails/AcceptForm'
import DeclineForm from './pages/applicationForm-2/ApplicationDetails/DeclineForm'

import MilestoneReport from './pages/MilestoneReport/index'
import EMDGNavBar, { EMDGMainNavContentItem } from './shared/EMDGNavBar'
import EMDGheader from './shared/EMDGHeader'
import EMDGheaderBrand from './shared/EMDGHeaderBrand'
import EmdgFooter from './shared/EmdgFooter'
// import EmdgFooterEnd from './shared/EmdgFooterEnd' REMOVED defined but never used.
import EmdgFooterNav from './shared/EmdgFooterNav'
import EmdglinkList from './shared/EmdgLinkList'
import ExportReadinessFrame from './pages/ExportReadinessFrame'

import { TierItem, GlobalDataContext } from './GlobalDataContext'
import { AdminPage } from './pages/AdminPage'
import AssignAgentToApplication from './pages/applicationForm-2/ApplicationDetails/AssignAgentToApplication'

interface LayoutProps {
  // eslint-disable-next-line react/no-unused-prop-types
  history: H.History
  location: H.Location
}

interface LayoutState {
    tierSettingsArr: TierItem[];
    // eslint-disable-next-line no-unused-vars
    refreshTierData: (data: TierItem[]) => void;
}

export class Layout extends React.Component<LayoutProps, LayoutState> {
  constructor(props: LayoutProps) {
      super(props)

      this.state = {
          tierSettingsArr: null,
          refreshTierData: this.refreshTierCallback,
      }
  }


    componentDidMount() {
      const isLoginPage = this.props.location.pathname.indexOf('/login') === 0
      if (!isLoginPage) {
        // Make the AJAX call here and update ajaxData except if it is login page where authorisation token will not be there
        fetch('/api/Dashboard/RetrieveTierSettings/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((data) => {
            this.setState({ tierSettingsArr: data })
            console.log('data:', data)
        })
        .catch((error) => {
            console.error('Error:', error)
        })
      }
    }

  componentDidUpdate(prevProps: LayoutProps, prevState: LayoutState) {
    if (this.props.location && prevProps.location) {
      if (this.props.location.pathname !== prevProps.location.pathname
        || this.props.location.search !== prevProps.location.search) {
        window.scroll(0, 0)
      }
    }
  }

  /* GlobalLink: React.SFC<LinkComponentTypeProps> = (props: React.PropsWithChildren<LinkComponentTypeProps>) => {
        return <a href={props.to} onClick={e => { e.preventDefault(); this.props.history.push(e.currentTarget.getAttribute("href")) }}>{props.children}</a>
    } */

    // used as a Callback for child components, not directly used by layout.tsx;
    refreshTierCallback = (data: TierItem[]) => {
        this.setState({ tierSettingsArr: data })
    }

  render() {
    let loggedIn = true
    const baseUrlExportReadiness = 'https://jolly-flower-083fde000-skippable.eastasia.5.azurestaticapps.net/'
    // const baseUrlExportReadiness = 'https://jolly-flower-083fde000.5.azurestaticapps.net/'

    // const baseUrlExportReadiness = 'http://localhost:3000/'

    let globalLinks: EMDGMainNavContentItem[] = [
      {
        link: '/',
        text: 'Home',
      },
      {
        link: '/profile',
        text: 'My Profile',
      },
      {
        link: '/logout',
        text: 'Logout',
      },
    ]

    if (location.pathname.indexOf('/claim') !== -1 || location.pathname.indexOf('/dashboard-form') !== -1 || location.pathname.indexOf('/guide') !== -1) {
      globalLinks = [
        {
          link: '/',
          text: 'Home',
        },
        {
          link: '/guide',
          text: 'Guide',
        },
        {
          link: '/profile',
          text: 'My Profile',
        },
        {
          link: '/logout',
          text: 'Logout',
        },
      ]
    }

    if (location.pathname.indexOf('/login') == 0) {
      loggedIn = false

      globalLinks = [
        {
          link: '/login',
          text: 'Login',
        },
        {
          link: '/login/announcement',
          text: 'Announcement',
        },
      ]
    }

    globalLinks = globalLinks.map((r) => ({
      ...r,
      active: (this.props.location.pathname.toLowerCase() == r.link
        || r.link != '/' && this.props.location.pathname.toLowerCase().indexOf(r.link) == 0 && loggedIn
        || r.link == '/' && this.props.location.pathname.toLowerCase().indexOf('/request') == 0),
    }))

      return (
      <div className="holder">
        <div className="wrapper">

          <EMDGheader dark>
            <div className="container-fluid">
              <EMDGheaderBrand
                link="/"
                brandImage="/images/logo.png"
                brandImageAlt="Australian Trader Commission"
                title="Export Market Development Grants"
                subline="Online Portal"
              />
            </div>
          </EMDGheader>

          <EMDGNavBar navLinks={globalLinks} />

          <main id="content">
            <div className="emdg-body">
              <GlobalDataContext.Provider value={this.state}>
              <Switch>
                <Route exact path="/login" component={LoginPage} />
                <Route exact path="/login/guide" component={Guide} />
                <Route exact path="/login/announcement" component={Announcement} />
                <Route exact path="/" component={DashboardPage} />
                <Route exact path="/dashboard-forms" component={DashboardFormsPage} />
                <Route exact path="/admin" component={AdminPage} />

                {/* <Route path="/dashboard-reform" render={(p) => <DashboardReformPage history={p.history} location={p.location} />} /> */}
                <Route
                  path="/dashboard-reform/:id/summary"
                  render={(p) => (
                    <ApplicationDetails
                      id={p.match.params.id}
                      location={p.location}
                      history={p.history}
                      showGrantAgreement={p.location.pathname.endsWith('/grantAgreement')}
                      showMilestoneReport={p.location.pathname.endsWith('/milestoneReport')}
                    />
                  )}
                />
                <Route
                    path="/dashboard-reform/:applicationID/assignAgent"
                    component={AssignAgentToApplication}
                />
                <Route
                  exact
                  path="/dashboard-reform/:id/grantAgreement/accept"
                  render={(p) => (
                    <AcceptForm id={p.match.params.id} history={p.history} />
                  )}
                />
                <Route
                  exact
                  path="/dashboard-reform/:id/grantAgreement/decline"
                  render={(p) => (
                    <DeclineForm id={p.match.params.id} history={p.history} />
                  )}
                />

                <Route exact path="/export-readiness" render={(p) => <ExportReadinessFrame baseUrl={baseUrlExportReadiness} history={p.history} />} />

                <Route exact path="/guide" component={Guide} />
                <Route exact path="/profile" component={ProfilePage} />
                <Route exact path="/profile/request" component={RequestPage} />
                <Route exact path="/threads" component={ThreadsPage} />
                <Route path="/claim/:id" render={(p) => <ApplicationForm1 claimId={p.match.params.id} history={p.history} location={p.location} />} />
                <Route path="/reform/:id" render={(p) => <ApplicationForm2 applicationId={p.match.params.id} history={p.history} location={p.location} />} />
                <Route path="/milestone-report/:id" render={(p) => <MilestoneReport milestoneID={p.match.params.id} history={p.history} location={p.location} />} />
                <Route exact path="/logout" component={LogoutPage} />
                <Route component={() => <div>Not Found</div>} />
              </Switch>
              </GlobalDataContext.Provider>
            </div>
          </main>

        </div>

        <div className="emdg-body emdg-body--dark footer mt-2">
          <EmdgFooter dark>
            <div className="container-fluid">
              <div className="row">
                <div className="emdg-header__brand">
                   <a className="emdg-header__brand-image" href="https://www.austrade.gov.au/">
                  <img className="emdg-header__brand-image-small" alt="Australian Trader Commission" src="/images/logo.png" />
                   </a>
                  <div className="emdg-header__text">
                    <p>In the spirit of reconciliation we acknowledge the Traditional Custodians of country throughout Australia and their connections to land, sea and community. We pay our respect to their elders past and present and extend that respect to all Aboriginal and Torres Strait Islander peoples today.</p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-8">
                  <nav>
                    <EmdgFooterNav>
                      <EmdglinkList
                        inline
                        items={[
                          { text: 'Contact us', link: 'https://www.austrade.gov.au/en/contact-us' },
                          { text: 'Privacy', link: 'https://www.austrade.gov.au/site-information/privacy-policy' },
                          { text: 'Site Disclaimer', link: 'https://www.austrade.gov.au/Site-information/Site-Disclaimer ' },
                          { text: 'Accessibility', link: 'https://www.austrade.gov.au/Site-information/Accessibility' },
                        ]}
                      />

                    </EmdgFooterNav>
                  </nav>
                </div>
                <div className="col-md-4 d-flex align-items-center justify-content-end">
                  <p>© 2024, Australian Trade and Investment Commission</p>
                </div>
              </div>



            </div>
          </EmdgFooter>
        </div>
      </div>
    )
  }
}
